module.exports = __webpack_public_path__ + "static/media/logob.b83168d5.png";